import SaveGameModel from "../model/SaveGameModel";

export default class SaveGameService {
    /**
     * @constructor
     * @param {SaveGameModel} saveGameModel
     */
    constructor(saveGameModel) {
        this._saveGameModel = saveGameModel;
    }

    clear() {
        this._saveGameModel.reset();
        this._clearLocalStorageSaveGameEntry();
    }

    saveGameExists() {
        return !!this._getSaveGameString();
    }

    saveGameVersionIsSynced() {
        const peekedSaveGame = this.peekSaveGame();
        if (!peekedSaveGame) {
            return false;
        }

        return peekedSaveGame.version === SaveGameModel.CURRENT_SAVE_GAME_VERSION;
    }

    peekSaveGame() {
        const saveGameString = this._getSaveGameString();
        if (!saveGameString) {
            return null;
        }

        try {
            return Object.freeze(JSON.parse(saveGameString));
        } catch (ex) {
            console.warn('[SaveGameService] Unable to peek save game.', ex);
            return null;
        }
    }

    load() {
        console.log(`[SaveGameService] Attempting to load save game...`);

        const saveGameString = this._getSaveGameString();
        if (!saveGameString) {
            this._saveGameModel.reset();
            console.log(`[SaveGameService] Save game doesn't exist!`);
            return;
        }

        return this._saveGameModel.deserialize(saveGameString)
            .then(() => {
                console.log(`[SaveGameService] Successfully deserialized save game`);
            })
            .catch(ex => {
                console.warn("[SaveGameService] Unable to deserialize save game, using a clean save game.", ex);
                
                this._saveGameModel.reset();
            });
    }

    save() {
        return this._saveGameModel.serialize()
            .then(saveGameString => {
                console.log("[SaveGameService] Save Game length", saveGameString.length);
                this._saveToLocalStorage(saveGameString);
            });
    }

    _saveToLocalStorage(saveGameString) {
        localStorage.setItem(SaveGameService.LOCAL_STORAGE_ID, saveGameString);
        console.log("[SaveGameService] Saved game to local storage.");
    }

    _clearLocalStorageSaveGameEntry() {
        localStorage.removeItem(SaveGameService.LOCAL_STORAGE_ID);
        console.log("[SaveGameService] Save game local storage entry cleared.");
    }

    _getSaveGameString() {
        return this._getSaveGameFromLocalStorage();
    }

    _getSaveGameFromLocalStorage() {
        const saveGameString = localStorage.getItem(SaveGameService.LOCAL_STORAGE_ID);
        if (!saveGameString) {
            console.log("[SaveGameService] No save game found in local storage");
        } else {
            console.log("[SaveGameService] Found save game in LocalStorage with a length of ", saveGameString.length);
        }

        return saveGameString;
    };
}

SaveGameService.LOCAL_STORAGE_ID = "ready_2_savegame";